import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditOrgStructureItem from '../../components/orgStructureItems/FormAddEditOrgStructureItem';

const CreateOrgStructureItem = () => (<WrapperSection><GlobalBreadcrumbs /><FormAddEditOrgStructureItem /></WrapperSection>);
export default CreateOrgStructureItem;
